module.exports = __webpack_public_path__ + "static/media/prism - annotated screen layout.17b0933c.png";